import React from 'react';
import scraperStyles from './scraper.module.css';
import { Grid, Box, Switch, Avatar, Stack, Typography } from '@mui/material';
import { StyledCard, StyledCardTitle, FlexDiv } from '../../../../../../../custom/components';

const Scraper = (props) => {

  const airlineList = props.airlineList || [];
  const enabledCount = (props.Scraper || []).filter((status) => status.value).length;
  const disabledCount = airlineList.length - enabledCount;

  return (
    <div>
      <Grid container direction={'row'} spacing={3}>
        <Grid item xs={12}>
          <StyledCard>
            <FlexDiv className={scraperStyles.headerRow}>
              <StyledCardTitle>NFD Status</StyledCardTitle>
            </FlexDiv>
            <Typography className={scraperStyles.subTitle}>
              Toggle airline-level NFD status availability.
            </Typography>

            <Grid container spacing={3} className={scraperStyles.layoutGrid}>
              <Grid item xs={12} md={4} lg={3}>
                <Box component='div' className={scraperStyles.insightPanel}>
                  <Typography className={scraperStyles.insightTitle}>Status Overview</Typography>
                  <Box component='div' className={scraperStyles.metricGrid}>
                    <Box component='div' className={scraperStyles.metricCard}>
                      <Typography className={scraperStyles.metricValue}>{airlineList.length}</Typography>
                      <Typography className={scraperStyles.metricLabel}>Total Airlines</Typography>
                    </Box>
                    <Box component='div' className={scraperStyles.metricCard}>
                      <Typography className={scraperStyles.metricValue}>{enabledCount}</Typography>
                      <Typography className={scraperStyles.metricLabel}>Enabled</Typography>
                    </Box>
                    <Box component='div' className={scraperStyles.metricCard}>
                      <Typography className={scraperStyles.metricValue}>{disabledCount}</Typography>
                      <Typography className={scraperStyles.metricLabel}>Disabled</Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={8} lg={9}>
                <Grid container spacing={2.5} className={scraperStyles.gridContainer}>
                  {airlineList.map((airline) => {
                    const isEnabled = props.Scraper && props.Scraper.find((status) => status.airlineId === airline.id)?.value;

                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        key={airline.id}
                        className={scraperStyles.gridItem}
                      >
                        <Box component='div' className={scraperStyles.airlineInfoContainer}>
                          <Stack direction={'column'} spacing={2}>
                            <Stack direction={'row'} alignItems={'center'} spacing={2} className={scraperStyles.topRow}>
                              <Avatar className={scraperStyles.avatar}>{airline.code}</Avatar>
                              <Box component='div'>
                                <Typography className={scraperStyles.code}>{airline.name}</Typography>
                                <Typography className={scraperStyles.airlineTag}>Airline</Typography>
                              </Box>
                            </Stack>

                            <Stack direction={'row'} alignItems={'center'} justifyContent='space-between' spacing={1} className={scraperStyles.bottomRow}>
                              {isEnabled ?
                                <Box component='div' className={`${scraperStyles.status} ${scraperStyles.enabled}`}>Enabled</Box>
                                :
                                <Box component='div' className={`${scraperStyles.status} ${scraperStyles.disabled}`}>Disabled</Box>
                              }
                              <Switch
                                name={airline.id}
                                size='small'
                                checked={isEnabled}
                                onChange={props.onChange}
                                className={scraperStyles.switch}
                                classes={{
                                  switchBase: scraperStyles.switchBase,
                                  checked: scraperStyles.switchChecked,
                                  track: scraperStyles.switchTrack,
                                  thumb: scraperStyles.switchThumb,
                                }}
                              />
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </StyledCard>
        </Grid>
      </Grid>
    </div>
  );
};

export default Scraper;